export default __webpack_public_path__ + "static/media/close-button.a4ccb0fa.svg";